import { useEffect, useRef } from 'react';

import { FlowConsumerContextEnergy } from '../../../../context';
import { getOffer } from '../../../../shared/helpers';
import { useFlowTracking } from '../../../../shared/hooks';
import { type OfferResponse } from '../../../../shared/types';

interface UseOfferTrackingParams {
  flowContext: FlowConsumerContextEnergy;
  offer?: OfferResponse;
  selectedDiscountCode?: string;
  discountCode?: string;
}

export function useOfferTracking({ flowContext, offer, selectedDiscountCode, discountCode }: UseOfferTrackingParams) {
  const { trackSelectItem } = useFlowTracking();
  const isInitialOfferSelectionRef = useRef(!discountCode);

  useEffect(() => {
    if (selectedDiscountCode) {
      const wasInitial = isInitialOfferSelectionRef.current;
      if (wasInitial) {
        isInitialOfferSelectionRef.current = false;
      }

      const selectedOffer = getOffer({ ...flowContext, discountCode: selectedDiscountCode }, offer);
      if (selectedOffer) {
        trackSelectItem(selectedOffer, offer, wasInitial);
      }
    }
  }, [selectedDiscountCode, flowContext, offer]);
}
